var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, privateMap) {
    if (!privateMap.has(receiver)) {
        throw new TypeError("attempted to get private field on non-instance");
    }
    return privateMap.get(receiver);
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, privateMap, value) {
    if (!privateMap.has(receiver)) {
        throw new TypeError("attempted to set private field on non-instance");
    }
    privateMap.set(receiver, value);
    return value;
};
var _jugglerTransforms, _j2h2Props;
import { Vec3D } from "./vec3d";
import { BBox3D } from "./bbox3d";
import { Matrix3D } from "./matrix3d";
import { Juggler } from "./juggler";
import { Prop } from "./prop";
export class Scene {
    constructor(jugglerCount) {
        this.jugglers = [];
        // translate, yrot(rad)
        _jugglerTransforms.set(this, []);
        this.props = [];
        _j2h2Props.set(this, []);
        const circV = new Vec3D(100, 0, 0);
        for (let j = 0; j < jugglerCount; j++) {
            let jtranslate = new Vec3D();
            // +z is pointing into screen, so to see juggler's face, we need to rotate 180
            let jrot = Math.PI;
            this.jugglers.push(new Juggler());
            if (jugglerCount > 1) {
                const rad = (j * 2 * Math.PI) / jugglerCount;
                jtranslate = circV.rotY(rad);
                jrot = rad + Math.PI / 2;
            }
            __classPrivateFieldGet(this, _jugglerTransforms).push([jtranslate, jrot]);
        }
    }
    setHandPosition(j, h, pos) {
        this.jugglers[j].setHandPosition(h, pos);
    }
    clearProps() {
        this.props = [];
        __classPrivateFieldSet(this, _j2h2Props, []);
    }
    finalizeProps() {
        for (let j = 0; j < __classPrivateFieldGet(this, _j2h2Props).length; j++) {
            const h2props = __classPrivateFieldGet(this, _j2h2Props)[j];
            if (typeof h2props === "undefined")
                continue;
            for (let h = 0; h < h2props.length; h++) {
                const props = h2props[h];
                if (typeof props === "undefined")
                    continue;
                for (let p = 0; p < props.length; p++) {
                    const prop = props[p];
                    const pos = this.jugglers[j].getPropInHandPosition(h, p, props.length);
                    prop.position = pos.clone();
                }
            }
        }
    }
    propAirborn(id, path, millis) {
        const prop = new Prop(id);
        prop.path = path;
        prop.pathMillis = millis;
        prop.position = path.posAt(millis);
        this.props.push(prop);
    }
    holdProp(j, h, id) {
        let h2props = __classPrivateFieldGet(this, _j2h2Props)[j];
        if (typeof h2props === "undefined") {
            h2props = [];
            __classPrivateFieldGet(this, _j2h2Props)[j] = h2props;
        }
        let props = h2props[h];
        if (typeof props === "undefined") {
            props = h2props[h] = [];
        }
        const prop = new Prop(id);
        props.push(prop);
        this.props.push(prop);
    }
    positionJugglers() {
        this.jugglers.forEach((juggler, j) => {
            const [translate, rotY] = __classPrivateFieldGet(this, _jugglerTransforms)[j];
            juggler.transform(translate, rotY);
        });
    }
    localizeVelocity(j, v) {
        return v.rotY(-__classPrivateFieldGet(this, _jugglerTransforms)[j][1]);
    }
    transformRelHandPosition(j, h, dpos) {
        const pos = this.jugglers[j].relHandPositionToAbs(h, dpos);
        let m = new Matrix3D();
        m = m.translate(__classPrivateFieldGet(this, _jugglerTransforms)[j][0]);
        m = m.rotateY(__classPrivateFieldGet(this, _jugglerTransforms)[j][1]);
        return m.transform(pos);
    }
    getBoundingBox() {
        let box = new BBox3D();
        for (const juggler of this.jugglers) {
            const jbox = juggler.getBoundingBox();
            box.merge(jbox);
        }
        for (const prop of this.props) {
            const pbox = prop.getBoundingBox();
            box.merge(pbox);
        }
        return box;
    }
}
_jugglerTransforms = new WeakMap(), _j2h2Props = new WeakMap();
